import React from 'react'
import "./WorkExpreiance.css"
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { MdGroupWork } from "react-icons/md";

function WorkExperiance() {


  const data = [
    {
      compnyName: "Google",
      position: "Full Stack Developer",
      des: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
      year: "2021-2022",
      techSkill: [
        {
          techName: "Node js"
        },

        {
          techName: "Express js"
        },

        {
          techName: "React js"
        },
        {
          techName: "Material UI"
        },
      ]
    },

    {
      compnyName: "Facebook",
      position: "UI/UX Designer",
      des: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
      year: "2020-2021",
      techSkill: [
        {
          techName: "Adob xd"
        },

        {
          techName: "Figma"
        },

        {
          techName: "Work Flow"
        },

      ]
    },

    {
      compnyName: "Facebook",
      position: "Flutter Developer",
      des: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
      year: "2019-2020",
      techSkill: [
        {
          techName: "Node js"
        },

        {
          techName: "Flutter js"
        },

        {
          techName: "Dart"
        },
      ]
    },
  ]

  const colors = [
    "#FFA233",
    "#336BFF",
    "#FF1043",
    "#33FFDD",
    "#8DFF33",

  ]


  return (
    <div id='expriance' className='container workexperiance-section'>

      <div className="section-titel">
        <h5>Work Expriance</h5>
        <span className='line1'></span>
      </div>

      <div className="timeline-section">
        <div className="con">
          <VerticalTimeline lineColor='#FF1043'>

            {data.map((item, index) => (
              <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{ background: colors[index], color: '#fff' }}
                contentArrowStyle={{ borderRight: '7px solid   #000' }}
                date={item.year}
                dateClassName="data-class"
                iconStyle={{ background: colors[index], color: '#fff' }}
                icon={<MdGroupWork />}
              >
                <h3 className="vertical-timeline-element-title">{item.compnyName}</h3>
                <h5 className="vertical-timeline-element-subtitle">{item.position}</h5>

                <div className="row">
                  {item.techSkill.map((tec, index) => (
                    <div className="col-xl-5 col-lg-3 col-md-6 col-sm-12" key={index}>
                      <div className="tech-skills">
                        <p>{tec.techName}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <p>
                  {item.des}
                </p>
              </VerticalTimelineElement>
            ))}





          </VerticalTimeline>
        </div>
      </div>



    </div>
  )
}

export default WorkExperiance